import React, { useEffect, useRef, useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send'
import SaveIcon from '@mui/icons-material/Save';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useValue } from '../../../context/ContextProvider';
import { EnviarNuevoProducto, actualizarProducto } from '../../../actions/productos';

const NuevoProducto = ({ openNuevoProducto, setOpenNuevoProducto, isUpdate, rowOriginal }) => {
    const codigoBarrasRef = useRef();
    const shortcutRef = useRef();
    const nombreProductoRef = useRef();
    const precioRef = useRef();
    const descRef = useRef();
    const habRef = useRef();
    const [habCheck, setHabCheck] = useState(true);
    const { state: { currentUser, productos, marcas, categorias }, dispatch } = useValue();
    const [codBarState, setCodBarState] = useState('');
    const [marcaState, setMarcaState] = useState('');
    const [tipoState, setTipoState] = useState('');
    const [categoriaState, setCategoriaState] = useState(null);
    const [precioState, setPrecioState] = useState(0);
    const [vStepState, setVStepState] = useState(0);        //Vendaje Step    -> El vendaje es la candidad adicional de panes por cantidad, Ej: compra 5 panes y se lleva uno extra
    const [vQtyState, setVQtyState] = useState(0);          //Vendaje cantidad adicional
    const [vUmbralState, setVUmbralState] = useState(0);    //Monto mínino para acceder a vendaje
    const [cStepState, setCStepState] = useState(0);        //Combo Step  -> El combo es el precio por cantidad, Ej: 7 empanadas por Bs 10
    const [cPriceState, setCPriceState] = useState(0);      //Precio del combo

    //console.log(rowOriginal);

    useEffect(() => {
        if (isUpdate) {
            rowOriginal.enF == 1 ? setHabCheck(true) : setHabCheck(false);
            setCodBarState(rowOriginal?.codBar);
            setMarcaState(rowOriginal?.brand);
            setCategoriaState(rowOriginal?.category);
            setTipoState(rowOriginal?.type);
            setPrecioState(rowOriginal?.price);
            setVStepState(rowOriginal.vStep);
            setVQtyState(rowOriginal.vQty);
            setVUmbralState(rowOriginal.vUmbral);
            setCStepState(rowOriginal.cStep);
            setCPriceState(rowOriginal.cPrice);
        } else {
            setCodBarState('');
            setMarcaState(null);
            setCategoriaState(null);
            setTipoState('General');
            setPrecioState(0);
        }

    }, [openNuevoProducto])

    const marcasOptions = marcas.map((marca) => (
        { id: marca.id, label: marca.marca }
    ))

    const categoriasOptions = categorias.map((categoria) => (
        { id: categoria.id, label: categoria.nombre }
    ))

    const handleClose = () => {
        setOpenNuevoProducto(false);
    }

    const handleTipoChange = (event) => {
        setTipoState(event.target.value);
    };

    const handleCodBarChange = (event) => {
        setCodBarState(event.target.value);
    };

    const handleCodBarBlur = () => {
        const prodExists = productos.find((p) => p.codBar == codBarState);
        if(prodExists) {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Código de Barras ya registrado.' } });
            codigoBarrasRef.current.focus();
            codigoBarrasRef.current.select();
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const codigoBarras = codigoBarrasRef.current.value;
            const shortcut = shortcutRef.current.value;
            const nombreProducto = nombreProductoRef.current.value;
            const precio = precioState;
            const tipo = tipoState;
            const descripcion = descRef.current.value;
            const id = isUpdate ? rowOriginal.id : 0;
            //const habilitado = isUpdate? habRef.current.value  : true;
            const nombreMarca = marcaState;
            const nombreCategoria = categoriaState;
            const habilitado = habCheck;
            const vStep = vStepState;
            const vQty = vQtyState;
            const vUmbral = vUmbralState;
            const cStep = cStepState;
            const cPrice = cPriceState;

            
            //console.log({ nombreMarca, nombreCategoria })

            let productosActualizados = null;
            let mensaje = null;
            if (isUpdate) {
                //const index = productos.map(object => object.id).indexOf(result.row[0].id);
                //const index = productos.findIndex(object => {
                //    return object.id === result.row[0].id;
                //});

                const result = await actualizarProducto({ id, codigoBarras, shortcut, nombreProducto, descripcion, nombreMarca, nombreCategoria, tipo, precio, vStep, vQty, vUmbral, cStep, cPrice, habilitado }, currentUser, dispatch);
                //console.log("Respuesta del servidor: ", result.rows);

                //Codigo para actualiza un objeto que está en el array de productos
                productosActualizados = productos.map(element => element.id == result.rows[0].id ? result.rows[0] : element);
                mensaje = 'Se actualizó el producto con éxito.'
            } else {
                //const result = await EnviarNuevoProducto({ id, codigoBarras, shortcut, nombreProducto, precio, tipo, descripcion, nombreMarca, nombreCategoria, habilitado }, currentUser, dispatch);
                const result = await EnviarNuevoProducto({ id, codigoBarras, shortcut, nombreProducto, descripcion, nombreMarca, nombreCategoria, tipo, precio, vStep, vQty, vUmbral, cStep, cPrice, habilitado }, currentUser, dispatch);
                //console.log("Respuesta del servidor: ", result.rows);

                productosActualizados = [...productos, result.rows[0]];
                mensaje = 'Se creo el producto con éxito.'
            }
            //console.log("Tabla productos actualizada: ", productosActualizados);
            dispatch({ type: 'UPDATE_PRODUCTOS', payload: { rows: productosActualizados } });
            setOpenNuevoProducto(false);
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: mensaje } });
        } catch (error) {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Error M020: No se pudo crear el producto. Compruebe su conexión.' } });
        }
    }


    let age = 15;


    return (
        <Dialog
            disableRestoreFocus={true}
            open={openNuevoProducto}
            onClose={handleClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                {isUpdate ? 'Editar Producto' : 'Nuevo Producto'}
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={handleClose}
                >
                    <CancelIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <Box paddingBottom={3}>
                        <DialogContentText>
                            {isUpdate ? 'Puede editar los siguientes campos:' : 'Por favor llene los siguientes campos:'}
                        </DialogContentText>
                    </Box>

                    <Stack direction='row' spacing={2} paddingBottom={3}>
                        <TextField
                            autoFocus={isUpdate ? false : true}
                            margin='normal'
                            variant='outlined'
                            id='codigoBarras'
                            label='Código de Barras'
                            type='text'
                            fullWidth
                            inputRef={codigoBarrasRef}
                            inputProps={{ minLength: 8 }}
                            required
                            onChange={handleCodBarChange}
                            onBlur={handleCodBarBlur}
                            //defaultValue={isUpdate ? rowOriginal?.codBar : ''}
                            value={codBarState}
                            disabled={isUpdate ? true : false}
                        />

                        <TextField
                            margin='normal'
                            variant='outlined'
                            id='shortcut'
                            label='Shortcut'
                            type='text'
                            fullWidth
                            inputRef={shortcutRef}
                            //inputProps={{ minLength: 3 }}
                            defaultValue={isUpdate ? rowOriginal?.scut : ''}
                        />
                    </Stack>

                    <Stack direction='row' spacing={2} paddingBottom={3}>


                        <TextField
                            autoFocus={isUpdate ? true : false}
                            margin='normal'
                            variant='outlined'
                            id='nombre'
                            label='Producto'
                            type='text'
                            //fullWidth
                            inputRef={nombreProductoRef}
                            inputProps={{ minLength: 2 }}
                            required
                            defaultValue={isUpdate ? rowOriginal?.product : ''}
                            style={{ width: '50%' }}
                        />

                        <TextField
                            //fullWidth
                            type="number"
                            label='Precio'
                            value={precioState}
                            variant="outlined"
                            inputRef={precioRef}
                            inputProps={{
                                maxLength: 7,
                                step: "0.5",
                            }}
                            onChange={(e) => setPrecioState(e.target.value ? parseFloat(e.target.value) : 0.00)}
                            onFocus={event => event.target.select()}
                            onBlur={(e) => { setPrecioState(e.target.value ? parseFloat(e.target.value).toFixed(2) : 0.00) }}
                            style={{ width: '24%' }}
                        />

                        <FormControl style={{ width: '24%' }}>
                            <InputLabel id="tipo-label">Tipo</InputLabel>
                            <Select
                                labelId="tipo-label"
                                id="tipo-simple-select"
                                //value={tipoState}
                                value={tipoState || ''} //debemos asegurarnos que el valor no sea nulo, de lo contrario de inicio se sobreponen el valor y el título
                                label="Tipo"
                                onChange={handleTipoChange}
                                required
                            //disabled
                            >
                                <MenuItem value={'General'}>General</MenuItem>
                                <MenuItem value={'Pan'}>Pan</MenuItem>
                            </Select>
                        </FormControl>
                    </Stack>

                    {/* Vendaje: Acordeon para configurar valores de Vendaje*/}
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Configuración Vendaje
                        </AccordionSummary>
                        <AccordionDetails>
                            <Stack direction='row' spacing={2} paddingBottom={3}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    label='Por cada x unidades'
                                    value={vStepState}
                                    variant="outlined"
                                    //inputRef={precioRef}
                                    inputProps={{
                                        maxLength: 4,
                                        step: "1",
                                    }}
                                    onChange={(e) => setVStepState(e.target.value ? parseInt(e.target.value) : 0)}
                                    onFocus={event => event.target.select()}
                                    onBlur={(e) => setVStepState(e.target.value ? parseInt(e.target.value) : 0)}
                                />
                                <TextField
                                    fullWidth
                                    type="number"
                                    label='Unidades extra'
                                    value={vQtyState}
                                    variant="outlined"
                                    //inputRef={precioRef}
                                    inputProps={{
                                        maxLength: 2,
                                        step: "1",
                                    }}
                                    onChange={(e) => setVQtyState(e.target.value ? parseInt(e.target.value) : 0)}
                                    onFocus={event => event.target.select()}
                                    onBlur={(e) => setVQtyState(e.target.value ? parseInt(e.target.value) : 0)}
                                />
                                <TextField
                                    fullWidth
                                    type="number"
                                    label='Monto mínimo (Bs)'
                                    value={vUmbralState}
                                    variant="outlined"
                                    //inputRef={precioRef}
                                    inputProps={{
                                        maxLength: 4,
                                        step: "0.5",
                                    }}
                                    onChange={(e) => setVUmbralState(e.target.value ? parseFloat(e.target.value) : 0.00)}
                                    onFocus={event => event.target.select()}
                                    onBlur={(e) => setVUmbralState(e.target.value ? parseFloat(e.target.value).toFixed(2) : 0.00)}
                                />
                            </Stack>
                        </AccordionDetails>
                    </Accordion>

                    {/* Combo: Acordeon para configurar valores de Combo*/}
                    <Accordion sx={{ marginBottom: 3 }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2-content"
                            id="panel2-header"
                        >
                            Configuración Combo
                        </AccordionSummary>
                        <AccordionDetails>
                            <Stack direction='row' spacing={2} paddingBottom={3}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    label='Cantidad unidades Combo'
                                    value={cStepState}
                                    variant="outlined"
                                    //inputRef={precioRef}
                                    inputProps={{
                                        maxLength: 4,
                                        step: "1",
                                    }}
                                    onChange={(e) => setCStepState(e.target.value ? parseInt(e.target.value) : 0)}
                                    onFocus={event => event.target.select()}
                                    onBlur={(e) => setCStepState(e.target.value ? parseInt(e.target.value) : 0)}
                                />
                                <TextField
                                    fullWidth
                                    type="number"
                                    label='Precio Combo (Bs)'
                                    value={cPriceState}
                                    variant="outlined"
                                    //inputRef={precioRef}
                                    inputProps={{
                                        maxLength: 4,
                                        step: "0.5",
                                    }}
                                    onChange={(e) => setCPriceState(e.target.value ? parseFloat(e.target.value) : 0.00)}
                                    onFocus={event => event.target.select()}
                                    onBlur={(e) => setCPriceState(e.target.value ? parseFloat(e.target.value).toFixed(2) : 0.00)}
                                />
                            </Stack>
                        </AccordionDetails>
                    </Accordion>

                    <Stack direction='row' spacing={2} paddingBottom={2}>
                        <Autocomplete
                            disablePortal={false}
                            id="combo-box-demo"
                            options={marcasOptions}
                            fullWidth
                            renderInput={(params) => <TextField {...params} label="marca" />}
                            ListboxProps={{ style: { maxHeight: 150 } }}
                            //defaultValue={isUpdate ? rowOriginal?.nombreMarca : ''}
                            disabled={isUpdate ? true : false}
                            value={marcaState}
                            onChange={(event) => setMarcaState(event.currentTarget.textContent)}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            required
                        />

                        <Autocomplete
                            disablePortal={false}
                            id="combo-box-demo"
                            options={categoriasOptions}
                            fullWidth
                            renderInput={(params) => <TextField {...params} label="categoría" />}
                            ListboxProps={{ style: { maxHeight: 150 } }}
                            //defaultValue={isUpdate ? rowOriginal?.nombreCategoria : ''}
                            value={categoriaState}
                            onChange={(event) => setCategoriaState(event.currentTarget.textContent)}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            required
                        />

                    </Stack>


                    <TextField
                        margin='normal'
                        variant='outlined'
                        id='desc'
                        type='text'
                        label='Descripcion'
                        fullWidth
                        inputRef={descRef}
                        inputProps={{ minLength: 6 }}
                        multiline
                        rows={2}
                        defaultValue={isUpdate ? rowOriginal?.descript : ''}
                        required
                    />

                    {isUpdate && <FormControlLabel control={
                        <Checkbox
                            checked={habCheck}
                            inputRef={habRef}
                            onChange={() => setHabCheck(!habCheck)}
                        />
                    } label="Registro habilitado" />}

                </DialogContent>
                <DialogActions sx={{ pr: '22px', pt: '20px' }}>
                    <Button onClick={handleClose} variant="outlined" startIcon={<CancelIcon />}>
                        Cancelar
                    </Button>
                    <Button type='submit' variant='contained' startIcon={<SaveIcon />}>
                        Guardar
                    </Button>
                </DialogActions>
            </form>
        </Dialog >

    )
}

export default NuevoProducto